import React from "react";
import { Check } from "lucide-react";

export const ChoiceButton = ({ selected, onClick, children, testid }) => (
  <button type="button" onClick={onClick} data-testid={testid} aria-pressed={selected}
    className={`w-full flex items-center justify-between gap-3 text-left px-4 min-h-[56px] rounded-2xl border text-[15px] font-medium transition-colors active:scale-[0.99] ${
      selected ? "border-neon bg-neon/10 text-white" : "border-white/10 bg-white/[0.03] text-white/90 hover:border-white/25 hover:bg-white/[0.06]"
    }`}>
    <span>{children}</span>
    <span className={`shrink-0 w-6 h-6 rounded-full border flex items-center justify-center ${selected ? "bg-neon border-neon text-black" : "border-white/20"}`}>
      {selected && <Check size={14} strokeWidth={3} />}
    </span>
  </button>
);
